import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {GatewayOPEEnum} from "./GatewayOPEEnum";

/**
 * O Inner Class
 */
class O {
  id!: number;
}

/**
 * I Inner Class
 */
class I {
  id!: number;
  macAddressGatewayId!: number;
}

export class AssignGatewayCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(GatewayOPEEnum.AssignGateway);
    this.i = new I();
    this.o = new O();
  }
}
